export const SOCIAL_PENDING_REQUESTS_SET = 'SOCIAL_PENDING_REQUESTS_SET';
export const SOCIAL_PRESENCE_MERGE = 'SOCIAL_PRESENCE_MERGE';
export const SOCIAL_DM_UNREAD_SET = 'SOCIAL_DM_UNREAD_SET';
